import 'react-app-polyfill/ie11'
import 'normalize.css'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import './shims'
import 'mathjax/es5/tex-mml-chtml'
import asciimath from 'mathjax/es5/input/asciimath'
import chtml from 'mathjax/es5/output/chtml'
window.MathJax.config.loader.load = [asciimath, chtml]
window.MathJax.config.asciimath = { delimiters: [['$', '$'], ['`', '`']] }

// import Latex from './components/Latex'

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
